import { FC } from 'react'
import { useGetList } from 'react-admin'
import { CertificateOut, AuditLogOut } from '../../types/apiRequests'
import { AuditTimeline } from './CertificateRelated'

interface Props {
  record: CertificateOut | undefined;
}

// Timeline content only: the surrounding card and title come from CertificateForm.
const CertificateLogs: FC<Props> = ({ record }) => {
  // Hook before the early return: the record is undefined on the first render after a reload.
  const {
    data: logs,
    isLoading,
    error,
  } = useGetList<AuditLogOut>('auditlog', {
    // eslint-disable-next-line camelcase
    filter: { certificate_id: record?.id },
    pagination: { page: 1, perPage: 50 },
    sort: { field: 'created', order: 'DESC' },
  }, { enabled: !!record })

  if (!record) return null

  return <AuditTimeline logs={logs} isLoading={isLoading} error={error} />
}

export default CertificateLogs
